import { useMemo } from 'react'
import { EmailWaitlistModal } from '../components/EmailWaitlistModal'
import { useAuth } from '../hooks/useAuth'
import { useLandingWaitlistPopup } from '../hooks/useLandingWaitlistPopup'
import { PRODUCT_DEFINITION_PL } from '../lib/seo/aeoContent'
import { buildLandingJsonLdGraph } from '../lib/seo/landingJsonLd'
import { usePageSeo } from '../lib/seo/usePageSeo'
import { absoluteUrl } from '../lib/seo/site'
import { FaqSection } from '../sections/FaqSection'
import { FooterSection } from '../sections/FooterSection'
import { HeaderNav } from '../sections/HeaderNav'
import { HeroBlockSection } from '../sections/HeroBlockSection'
import { JournalFeatureSection } from '../sections/JournalFeatureSection'
import { LandingAppSection } from '../sections/LandingAppSection'
import { LandingIntroSection } from '../sections/LandingIntroSection'
import { LandingPartnersSection } from '../sections/LandingPartnersSection'
import { LandingPatronageSection } from '../sections/LandingPatronageSection'
import { LandingMapSection } from '../sections/LandingMapSection'
import { LandingNewsSection } from '../sections/LandingNewsSection'
import { LandingStampsShowcase } from '../sections/LandingStampsShowcase'
import { SocialProofSection } from '../sections/SocialProofSection'

export function LandingPage() {
  const { isLoading: authLoading, isLoggedIn } = useAuth()
  const { open: waitlistPopupOpen, dismiss: dismissWaitlistPopup, markSubmitted } =
    useLandingWaitlistPopup({ authLoading, isLoggedIn })

  const landingJsonLd = useMemo(
    () => buildLandingJsonLdGraph(absoluteUrl('/').replace(/\/$/, '') || 'https://paszportdolnegoslaska.pl'),
    [],
  )

  usePageSeo({
    title: 'Paszport Dolnego Śląska 2026 - Turystyczny Paszport Dolnego Śląska',
    description: PRODUCT_DEFINITION_PL,
    pathname: '/',
    keywords:
      'Paszport Dolnego Śląska, Dolny Śląsk, atrakcje, turystyka, wycieczki, 2026, pieczątki, 12 miejsc, Lower Silesia tourism passport, regional tourism program',
    jsonLd: landingJsonLd,
    jsonLdScriptId: 'landing-website-jsonld',
  })

  return (
    <div className="min-h-dvh bg-paper text-ink">
      <HeaderNav />
      <main>
        <HeroBlockSection />
        <LandingIntroSection />
        <LandingPatronageSection />
        <LandingPartnersSection />
        <LandingMapSection />
        <LandingStampsShowcase />
        <LandingAppSection />
        <SocialProofSection />
        <JournalFeatureSection />
        <LandingNewsSection />
        <FaqSection />
      </main>
      <FooterSection />
      <EmailWaitlistModal
        open={waitlistPopupOpen}
        onDismiss={dismissWaitlistPopup}
        onSubmitted={markSubmitted}
      />
    </div>
  )
}
